<template>
  <div class="centerx">
    <vs-popup
      classContent="popup-example"
      :title="$t('customers.label.service_activation')"
      :active.sync="openPopUp"
      class="popup-close"
    >
      <ValidationObserver ref="observer">
        <form>
          <h5 class="service-heading">
            {{ $t("customers.label.service_details") }}
          </h5>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mt-5">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.add_service")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="add service"
                  :key="resetKey"
                >
                  <v-select
                    label="serviceCode"
                    v-model="selectedServiceId"
                    :options="serviceTemplate"
                    placeholder="Select Service"
                    :reduce="(serviceCode) => serviceCode.id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    @input="handlerServiceChange"
                    class="min-w-200 w-full"
                  >
                    <template slot="option" slot-scope="option"
                      >{{ option.serviceCode }} ---
                      {{ option.serviceDescription }}</template
                    >
                  </v-select>
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div
              class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mt-5"
              v-if="networkNodeActive"
            >
              <div class="dropdown-with-label" v-if="detailsdropdown">
                <small class="date-label"
                  >{{ $t("customers.label.network_node")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="network node"
                  :key="resetKey"
                >
                  <v-select
                    label="systemname"
                    v-model="networknode"
                    :options="networkNodeOptions"
                    placeholder="Select One"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    @input="networkNodeSelect"
                    class="min-w-200 w-full"
                  >
                    <template slot="option" slot-scope="option">{{
                      option.systemname
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <vs-input
                v-else
                :label="$t('customers.label.network_node')"
                v-model="networknode"
                disabled
                class="w-full mb-2 font-semibold starlabel"
              />
            </div>
          </div>
          <h5 class="service-heading">
            {{ $t("customers.label.device_details") }}
          </h5>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.serial_no")
                  }}<span class="required">*</span></small
                >
                <vue-simple-suggest
                  v-model="deviceSerialNumber"
                  :list="itemList.serialNumbers"
                  @input="deviceSerialNumberCheck"
                  value-attribute="item"
                  display-attribute="item"
                  :filter-by-query="true"
                >
                </vue-simple-suggest>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="item"
                :key="resetKey"
              >
                <vs-input
                  :label="$t('customers.label.item')"
                  v-model="deviceItemType"
                  class="w-full font-semibold mb-2 starlabel"
                />
                <span class="validate-error" style="color: red">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.discount_code")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="discount code"
                  :key="resetKey"
                >
                  <v-select
                    label="discountDescription"
                    v-model="deviceDiscountId"
                    :options="saleTemplate.discountMasterDatas"
                    placeholder="Select Discount"
                    :reduce="(serviceCode) => serviceCode.id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    @input="handlerServiceChange"
                    class="min-w-200 w-full"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="total price"
                :key="resetKey"
              >
                <vs-input
                  :label="$t('customers.label.total_price')"
                  v-model="deviceUnitPrice"
                  class="w-full font-semibold mb-2 starlabel"
                />
                <span class="validate-error" style="color: red">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div
            v-if="Object.keys(deviceDetails).length && deviceDetails.isPairing === 'Y'"
          >
            <h5 class="service-heading">Paired Item Details</h5>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("customers.label.serial_no")
                    }}<span class="required">*</span></small
                  >
                  <vue-simple-suggest
                    v-model="pairedItemSerialNumber"
                    :list="itemList.serialNumbers"
                    @input="pairedDeviceSerialNumberCheck"
                    value-attribute="item"
                    display-attribute="item"
                    :filter-by-query="true"
                  >
                  </vue-simple-suggest>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="item"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('customers.label.item')"
                    v-model="pairedItemType"
                    class="w-full font-semibold mb-2 starlabel"
                  />
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("customers.label.discount_code")
                    }}<span class="required">*</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="dicsount code"
                    :key="resetKey"
                  >
                    <v-select
                      label="discountDescription"
                      v-model="pairedDiscountId"
                      :options="saleTemplate.discountMasterDatas"
                      placeholder="Select Discount"
                      :reduce="(serviceCode) => serviceCode.id"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      @input="handlerServiceChange"
                      class="min-w-200 w-full"
                    >
                    </v-select>
                    <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="total price"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('customers.label.total_price')"
                    v-model="pairedUnitPrice"
                    class="w-full font-semibold mb-2 starlabel"
                  />
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <h5 class="service-heading">
            {{ $t("customers.label.plan_details") }}
          </h5>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.plan_list")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="plan list"
                  :key="resetKey"
                >
                  <v-select
                    label="name"
                    v-model="selectedServicePlanId"
                    :options="planPacks"
                    placeholder="Select One"
                    @input="fetchPlans"
                    :reduce="(name) => name.id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                  />
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.plan") }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="plan"
                  :key="resetKey"
                >
                  <v-select
                    label="planDescription"
                    v-model="selectedPlan"
                    :options="planList"
                    @input="planSelected"
                    placeholder="Select Plan"
                    :reduce="(name) => name.id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template slot="option" slot-scope="option"
                      >{{ option.planCode }} --- {{ option.planDescription }}</template
                    >
                  </v-select>
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.start_date")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="start date"
                  :key="resetKey"
                >
                  <datepicker
                    :placeholder="$t('customers.label.select_date')"
                    v-model="startDate"
                    class="mb-2 font-semibold"
                  />
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.charge_cycle")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="charge cycle"
                  :key="resetKey"
                >
                  <v-select
                    label="subscriptionPeriod"
                    v-model="contractPeriod"
                    :options="saleTemplate.contractPeriods"
                    placeholder="Select Plan"
                    :reduce="(planCode) => planCode.id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.contract_period")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="contract period"
                  :key="resetKey"
                >
                  <v-select
                    label="chargeCode"
                    v-model="chargeCycle"
                    :options="chargeCycleOptions"
                    placeholder="Select Plan"
                    :reduce="(planCode) => planCode.chargeCode"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="center mb-2">
            <span class="ml-1 mr-1">
              <vs-button
                @click="serviceActivationSubmit"
                class="footerButton-next"
                :disabled="!deviceSerialNumber"
                style="top: 0px"
                >{{ $t("customers.label.submit") }}</vs-button
              >
            </span>
          </div>
        </form>
      </ValidationObserver>
    </vs-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import vSelect from "vue-select";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import Datepicker from "vuejs-datepicker";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import moment from "moment";
export default {
  props: {
    openPopUp: {
      type: Boolean,
      default: false,
    },
    networkNodeActive: {
      type: Boolean,
      default: false,
    },
    detailsdropdown: {
      type: Boolean,
      default: false,
    },
    customerId: {
      type: [String, Number],
    },
  },
  components: {
    "v-select": vSelect,
    VueSimpleSuggest,
    Datepicker,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      resetKey: 0,
      networknode: "",
      selectedServiceId: "",
      // device details
      deviceDetailsObj: {},
      deviceSerialNumber: "",
      deviceItemType: "",
      deviceDiscountId: "",
      deviceUnitPrice: 0,
      // Paired Item Details
      pairedItemSerialNumber: "",
      pairedItemType: "",
      pairedDiscountId: "",
      pairedUnitPrice: 0,
      // plan details
      selectedServicePlanId: "",
      selectedPlan: "",
      startDate: "",
      chargeCycle: "",
      contractPeriod: "",
      ////
      serialitemdetail: [],
      chargeCycleOptions: [],
      planList: [],
      //plan
      plan: {},
    };
  },
  computed: {
    ...mapState({
      serviceTemplate: (state) => state.customer.serviceTemplate,
      networkNodeTemplate: (state) => state.customer.networkNodeTemplate,
      saleTemplate: (state) => state.customer.saleTemplate,
      pairedItemList: (state) => state.customerActivation.pairedItemList,
      contractData: (state) => state.customer.contractData,
      clientDetail: (state) => state.customer.clientDetailData,
      quoteList: (state) => state.leads.quoteList, // for preselect data
      itemList: (state) => state.customerActivation.itemList,
      itemList2: (state) => state.customer.itemList2,
      planPacks: (state) => state.customer.planPacks,
      itemDetail: (state) => state.customerActivation.itemDetail,
      deviceDetails: (state) => state.customerActivation.deviceDetails,
      pairedItemDetails: (state) => state.customerActivation.pairedItemDetails,
      saleTemplateList: (state) => state.customerActivation.saleTemplateList,
    }),
    networkNodeOptions() {
      if (Object.keys(this.networkNodeTemplate).length) {
        return this.networkNodeTemplate[0].details;
      } else return [];
    },
  },
  watch: {
    openPopUp(val) {
      if (!val) {
        this.resetKey++;
        this.$emit("onclose");
        return;
      }
      this.findAndRender();
    },
  },
  methods: {
    async findAndRender() {
      try {
        await this.$store.dispatch("customer/getPlanPackAction");
        await this.$store.dispatch("customer/setClientServiceTemplate");
        if (this.clientDetail.quoteId && this.clientDetail.quoteId.length) {
          const response = await this.$store.dispatch(
            "customerActivation/getLeadIdbyQuoteNumber",
            this.clientDetail.quoteId
          );
          await this.$store.dispatch("leads/fetchAllQuotesInfo", response.data.leadId);
          this.selectedServiceId = this.quoteList[0].serviceId;
          await this.$store.dispatch(
            "customer/setClientNetworkTemplate",
            this.selectedServiceId
          );
        }
        await this.$store.dispatch("customer/setSaleTemplate");
        this.$emit("initSetNetwork");
      } catch (error) {
        this.$toasted.error("something wrong!!");
      }
    },
    async pairedDeviceSerialNumberCheck() {
      // pairedItemDetails
      await this.$store.dispatch("customerActivation/setItemDetailsByQuery", {
        loc: this.clientDetail.accountInfo.office.id,
        sl: this.pairedItemSerialNumber,
      });
      // await this.$store.dispatch("customer/setPairedItemDetails",
      //
      //   this.pairedItemSerialNumber
      // );
      if (this.pairedItemSerialNumber != "") {
        await this.$store.dispatch("customerActivation/setItemDetails", {
          loc: this.clientDetail.accountInfo.office.id,
          sl: this.pairedItemSerialNumber,
          type: "pairedItemDetails",
        });
        this.pairedItemType = this.pairedItemDetails.itemCode;
        this.pairedDiscountId = 1;
      }
    },
    async deviceSerialNumberCheck() {
      await this.$store.dispatch("customerActivation/setItemDetailsByQuery", {
        loc: this.clientDetail.accountInfo.office.id,
        sl: this.deviceSerialNumber,
      });
      if (this.deviceSerialNumber != "") {
        await this.$store.dispatch("customerActivation/setItemDetails", {
          loc: this.clientDetail.accountInfo.office.id,
          sl: this.deviceSerialNumber,
          type: "deviceDetails",
        });
        this.deviceItemType = this.deviceDetails.itemCode;
        this.deviceDiscountId = 1;
      }
    },
    async fetchPlans(val) {
      await this.$store.dispatch("customerActivation/getSalesTemplateList", val);
      this.planList = this.saleTemplateList.filter(
        (obj, index, self) => index === self.findIndex((item) => item.id === obj.id)
      );
    },
    async planSelected(val) {
      this.plan = this.saleTemplateList.find((el) => el.id == val);
      this.contractPeriod = this.plan.contractPeriodId;
      if (this.plan.isPrepaid == "N") {
        this.contractPeriod = 1;
      }
      this.chargeCycleOptions = [...this.plan.availableServices];
      this.chargeCycle = this.plan.chargeCycle;
    },
    async handlerServiceChange() {
      await this.$store.dispatch(
        "customer/setClientNetworkTemplate",
        this.selectedServiceId
      );
      this.$emit("networkActive");
    },
    async serviceActivationSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      let payload = {
        clientData: [],
        clientServiceData: [
          {
            clientServiceDetails: [
              {
                status: "new",
                parameterId:
                  (this.networkNodeTemplate[0] &&
                    this.networkNodeTemplate[0].paramName) ||
                  "",
                parameterValue:
                  (this.networkNodeTemplate[0] &&
                    this.networkNodeTemplate[0].details[0] &&
                    this.networkNodeTemplate[0].details[0].id) ||
                  "",
              },
            ],
            serviceId: this.selectedServiceId,
            accountNo: this.clientDetail.accountNumber,
          },
        ],
        deviceData: [
          {
            locale: "en",
            dateFormat: "dd MMMM yyyy",
            officeId: this.deviceDetails.officeId.toString(),
            itemId: this.deviceDetails.itemMasterId,
            chargeCode: this.deviceDetails.chargeCode,
            unitPrice: this.deviceDetails.unitPrice,
            quantity: "1",
            discountId: this.deviceDiscountId,
            totalPrice: this.deviceDetails.unitPrice,
            saleType: "NEWSALE",
            saleDate: moment().format("DD MMMM YYYY"),
            serialNumber: [
              {
                serialNumber: this.deviceSerialNumber,
                status: "allocated",
                saleType: "NEWSALE",
                itemMasterId: this.deviceDetails.itemMasterId,
                isNewHw: "Y",
                itemType: this.deviceDetails.itemCode,
              },
            ],
            isPairing: this.deviceDetails.isPairing,
          },
        ],
        planData: [
          {
            billAlign: false,
            autoRenew: "",
            planCode: this.plan.id,
            planName: this.plan.planCode,
            planPoId: this.plan.planPoId,
            dealPoId: this.plan.dealPoId,
            contractPeriod:
              this.plan.isPrepaid === "N"
                ? this.contractPeriod
                : this.plan.contractPeriodId,
            paytermCode: this.plan.chargeCycle,
            isNewplan: true,
            locale: "en",
            dateFormat: "dd MMMM yyyy",
            start_date: moment(this.startDate).format("DD MMMM YYYY"),
            channel: "NGB Client",
          },
        ],
      };
      if (this.deviceDetails.isPairing === "Y") {
        payload.deviceData[0].pairableItemDetails = {
          locale: "en",
          dateFormat: "dd MMMM yyyy",
          officeId: this.pairedItemDetails.officeId.toString(),
          itemId: this.pairedItemDetails.itemMasterId,
          chargeCode: this.pairedItemDetails.chargeCode,
          unitPrice: this.pairedItemDetails.unitPrice,
          quantity: "1",
          discountId: this.pairedDiscountId,
          totalPrice: this.pairedItemDetails.unitPrice,
          saleType: "NEWSALE",
          saleDate: moment().format("DD MMMM YYYY"),
          serialNumber: [
            {
              serialNumber: this.pairedItemSerialNumber,
              status: "allocated",
              saleType: "NEWSALE",
              itemMasterId: this.pairedItemDetails.itemMasterId,
              isNewHw: "Y",
              itemType: this.pairedItemDetails.itemCode,
            },
          ],
          isPairing: this.pairedItemDetails.isPairing,
        };
      }
      try {
        await this.$store.dispatch("customer/serviceActivationAction", {
          id: this.customerId,
          data: payload,
        });
        this.$emit("onSuccess");
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Service Activated Successfully!",
          type: "success",
        });
        this.resetForm();
      } catch (error) {
        this.$toasted.error(e.message);
      }
    },
    resetForm() {
      (this.selectedServiceId = ""),
        (this.networknode = ""),
        (this.deviceSerialNumber = ""),
        (this.deviceItemType = ""),
        (this.deviceDiscountId = ""),
        (this.deviceUnitPrice = ""),
        (this.pairedItemSerialNumber = ""),
        (this.pairedItemType = ""),
        (this.pairedDiscountId = ""),
        (this.pairedUnitPrice = ""),
        (this.selectedServicePlanId = ""),
        (this.selectedPlan = ""),
        (this.startDate = ""),
        (this.contractPeriod = ""),
        (this.chargeCycle = "");
    },
    networkNodeSelect() {
      //
    },
  },
  mounted() {
    this.resetForm();
  },
};
</script>
